"use strict";

var _taggedTemplateLiteral = require("/home/circleci/top-up-app/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  background-color: ", ";\n  color: ", ";\n  display: flex;\n  justify-content: space-between;\n  padding: 0 48px;\n  align-items: center;\n  height: 48px;\n\n  ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.navbar = void 0;

var _core = require("@emotion/core");

var _mediaQueries = require("../../utils/mediaQueries");

var navbar = function navbar(_ref) {
  var theme = _ref.theme;
  return (0, _core.css)(_templateObject(), theme.bColorneutral08, theme.bColorneutral01, (0, _mediaQueries.mq)({
    padding: ['0 20px', '0 20px', '0 20px', '0 48px', '0 48px']
  }));
};

exports.navbar = navbar;